import { usePasswordResetMutation } from '@/features/user/userApi';
import SettingsViewWrapper from '@/shared/components/SettingsViewWrapper/SettingsViewWrapper';
import { removeTags } from '@/shared/helpers/formatters';
import { useUser } from '@/shared/hooks/user';
import { ResponseRTK } from '@/types/rtkCustomTypes';
import { IonButton, IonText, ToastOptions, useIonToast } from '@ionic/react';
import { useTranslation, withTranslation } from 'react-i18next';
import styles from './Password.module.css';

const Password: React.FC = () => {
  const { t } = useTranslation();
  const [presentToast] = useIonToast();
  const [passwordReset] = usePasswordResetMutation();
  const user = useUser();
  const onPasswordChanged = async () => {
    const responseFromPWReset: ResponseRTK<unknown> = await passwordReset({ user: { email: user?.email } });
    const isSuccess = !('error' in responseFromPWReset);

    const result: ToastOptions = {
      message: isSuccess
        ? removeTags(t('reset_password.requested'))
        : 'Email konnte nicht gesendet werden. Bitte versuchen Sie es später noch einmal.',
      duration: 2000,
      position: 'top',
      color: isSuccess ? 'success' : 'danger'
    };

    await presentToast(result);
  };

  return (
    <SettingsViewWrapper name="password-page" title={t('data.password')}>
      <IonText>{t('data.change_password_text')}</IonText>
      <div className={styles.buttonWrapper}>
        <IonButton onClick={onPasswordChanged} disabled={!user?.email}>
          {t('data.change_password_link')}
        </IonButton>
      </div>
    </SettingsViewWrapper>
  );
};

export default withTranslation()(Password);
